module.exports = __webpack_public_path__ + "static/media/activity-log-icon.a1dc77d0.svg";